/**
 * 3.1.3.2 외부 연동 블랙리스트 사이트 Tab Store
 *
 * @since 2018-08-02
 * @author devp020
 */
import {i18n} from '~/plugins/i18n'
import compareObject from '~/utils/compare'

const initBlackListData = () => {
  return {
    device_id_list: [],
    device_list_name: '',
    blist_site_cm_bidir_yn: 1,
    blist_site_cm_desc: '',
    blist_site_cm_device: [],
    blist_site_cm_id: 1,
    blist_site_cm_sync_yn: 1,
    blist_site_cm_term: 1,
    blist_site_cm_ttl: 100,
    blist_site_cm_uname: '',
    blist_site_cm_url_val: '',
    blist_site_cm_use_yn: 1
  }
}
export const state = () => ({
  selectHourOptions: [
    {label: '01', value: 1}, {label: '02', value: 2}, {label: '03', value: 3}, {label: '04', value: 4}, {label: '05', value: 5}, {label: '06', value: 6}, {label: '07', value: 7}, {label: '08', value: 8}, {label: '09', value: 9}, {label: '10', value: 10}, {label: '11', value: 11}, {label: '12', value: 12}, {label: '13', value: 13}, {label: '14', value: 14}, {label: '15', value: 15}, {label: '16', value: 16}, {label: '17', value: 17}, {label: '18', value: 18}, {label: '19', value: 19}, {label: '20', value: 20}, {label: '21', value: 21}, {label: '22', value: 22}, {label: '23', value: 23}, {label: '24', value: 24}
  ],
  // api url 목록
  apiUrl: {
    blacklistSiteUrl: '/api/cm/blist-site-cm'
  },

  // iap info
  blacklistSiteList: [],
  selectedData: initBlackListData(),
  blacklistSiteResult: null,
  blacklistSiteSyncResult: null,
  selectRowItem: {}
})

export const mutations = {
  // Row DoubleClick
  setSelectRowItem (state, data) {
    state.selectRowItem = data
  },
  // 블랙리스트 사이트 조회
  mutBlacklistSite (state, payload) {
    state.blacklistSiteList = payload.filter(item => {
      // item.device_id_list = '<div>' + item.blist_site_cm_device.map(item => {
      //   return item.device_uname
      // }).join('</div><div>') + '</div>'
      item.device_id_list = item.blist_site_cm_device.map(itm => itm.device_id)
      return item
    })
  },
  // 블랙리스트 사이트 편집 데이터 조회
  mutBlacklistSiteGetData (state, data) {
    const selectedRowData = data[0]
    selectedRowData.device_list_name = ''
    selectedRowData.device_id_list = []
    const deviceInfo = selectedRowData.blist_site_cm_device
    if (deviceInfo.length > 0) {
      const deviceName = deviceInfo[0].device_uname
      const deviceLen = deviceInfo.length
      let result = void 0
      if (deviceLen > 1) {
        // result = `${deviceName} 외 ${deviceLen - 1} 대`
        result = i18n.t('cmn.deviceTypeText', {name: deviceName, cnt: deviceLen - 1})
      } else if (deviceLen === 1) {
        result = `${deviceName}`
      } else {
        result = ''
      }
      selectedRowData.device_list_name = result
      selectedRowData.device_id_list = deviceInfo.map(item => item.device_id)
    }
    state.selectedData = selectedRowData
  },
  // 블랙리스트 사이터 편집 데이터 초기화
  mutBlacklistSiteResetData (state) {
    state.selectedData = initBlackListData()
  },
  // 블랙리스트 사이트 (빈설정)
  mutAddEmptySettings: (state, item) => {
    state.blacklistSiteList.push(item)
  },
  // 블랙리스트 사이트 완료 처리 / 수정
  mutPutBlacklistSite (state, payload) {
    state.blacklistSiteResult = payload
  },
  // 블랙리스트 사이트 삭제
  mutDelBlacklistSite (state, itemIndexList) {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.blacklistSiteResult.splice(itemIndex, 1)
    }
  },
  // 블랙리스트 사이트 사용여부 수정
  mutPutBlacklistSiteSync (state, payload) {
    state.blacklistSiteSyncResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  // 블랙리스트 사이트 조회
  async acsBlacklistSite ({commit, state}) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.blacklistSiteUrl}/0`, {loading: false})
      if (res.code === 'ok') {
        commit('mutBlacklistSite', res.result)
      } else {
        commit('mutBlacklistSite', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 블랙리스트 사이트 편집 데이터 조회
  async acsBlacklistSiteGetData ({commit, state}, blackListId) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.blacklistSiteUrl}/${blackListId}`)
      if (data.code !== 'ok') {
        commit('mutBlacklistSiteGetData', {})
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutBlacklistSiteGetData', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 블랙리스트 사이트 (빈설정)
  async acsAddEmptySettings ({commit, state}) {
    const param = _.omit(state.selectedData, ['blist_site_cm_id'])
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.blacklistSiteUrl}`, param, {loading: false, successAlert: false})
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 블랙리스트 사이트 완료 처리 / 수정
  async acsPutBlacklistSite ({commit, state}) {
    const result = { error: null }
    const params = state.selectedData
    // 수정 인 경우 device_id 추가
    if (state.selectedData.device_id_list === undefined) {
      params.device_id_list = []
      state.selectedData.blist_site_cm_device.forEach(item => {
        params.device_id_list.push(item.device_id)
      })
    }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.blacklistSiteUrl}`, params, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutPutBlacklistSite', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 블랙리스트 사이트 삭제
  async acsDelBlacklistSite ({commit, state}, param) {
    const result = { error: null }
    try {
      const data = await this.$axios.$post(`${state.apiUrl.blacklistSiteUrl}/multi`, param.idList, {loading: false, successAlert: false})
      if (data.code === 'ok') {
        // commit('mutDelBlacklistSite', param.idList)
        return 'ok'
      } else {
        result.error = data.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 블랙리스트 사이트 사용여부 수정
  async acsPutBlacklistSiteSync ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.blacklistSiteUrl}/multi`, payload)
      if (res.code === 'ok') {
        commit('mutPutBlacklistSiteSync', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async onEventRuleChkInputAxios ({commit, state}, param) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.blacklistSiteUrl}/multi`, param, {loading: false, successAlert: false})

      if (data.code !== 'ok') {
        return false
      }
      return data
    } catch (error) {
      return error
    }
  }
}

export const getters = {
  compareBlackListSiteData (state) {
    return compareObject(state.blSiteInfo, state.blSiteInfoClone)
  }
}

export const strict = false
